import api from "@/lib/api";

// Meldet Client-Ereignisse (abgefangene Fehler, Versionswechsel) ans Backend-Audit-Log.
// Immer "fire and forget" — darf die App niemals blockieren oder selbst Fehler werfen.
export function reportClientEvent(payload = {}) {
  try {
    const body = {
      type: payload.type || "client_event",
      message: (payload.message || "").toString().slice(0, 2000),
      path: (payload.path || (typeof window !== "undefined" ? window.location.pathname : "")).toString().slice(0, 300),
      component: (payload.component || "").toString().slice(0, 200),
      app_version: payload.app_version ? String(payload.app_version).slice(0, 40) : undefined,
      user_agent: typeof navigator !== "undefined" ? String(navigator.userAgent).slice(0, 400) : "",
    };
    api.post("/telemetry/client-event", body).catch(() => {});
  } catch (e) {
    /* niemals werfen */
  }
}
